import React, { useState } from 'react'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
import { useSnackbar } from 'notistack'
import { Grid, IconButton } from '@material-ui/core'
import SendIcon from '@material-ui/icons/Send'
import { primaryB, secondaryB } from 'asterX-UIkit/constants/colors'
import AsterTextField from 'asterX-UIkit/Inputs/AsterTextField'
import AsterButton from 'asterX-UIkit/Buttons/AsterButton'
import { postPhoto, updateSupportById } from 'requests/misc'
import { InsertDriveFileOutlined } from '@material-ui/icons'
import AttachFileIcon from '@material-ui/icons/AttachFile'

const bytesToMB = bytes => {
  if (bytes === 0) return '0 MB'
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`
}

const FileMessage = ({ handleDownload, url, size, fileName }) => {
  return (
    <Grid
      item
      container
      alignItems="center"
      xs={12}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        flexWrap: 'nowrap'
      }}
    >
      <div>
        <IconButton
          onClick={() => handleDownload(url)}
          style={{ margin: 0, padding: 0, marginRight: 5 }}
        >
          <InsertDriveFileOutlined />
        </IconButton>
      </div>
      <div
        style={{
          margin: 0,
          padding: 0,
          wordBreak: 'break-word'
        }}
      >
        <div style={{ margin: 0, padding: 0, fontSize: 12 }}>{fileName}</div>
        <div style={{ margin: 0, padding: 0, fontSize: 12 }}>
          {bytesToMB(size)}
        </div>
      </div>
    </Grid>
  )
}

const ChatModal = ({ id, chat, setChat }) => {
  const { enqueueSnackbar } = useSnackbar()
  const currentUser = jwtDecode(localStorage.getItem('token'))
  const [message, setMessage] = useState('')

  const handleSend = (file = null) => {
    if (!message.length && !file) {
      enqueueSnackbar('Заполните поле сообщения!', {
        variant: 'error'
      })
      return
    }
    updateSupportById({
      id: id,
      chat: JSON.stringify([
        ...chat,
        {
          message,
          fullName: `${currentUser.firstName} ${currentUser.lastName}`,
          author: currentUser.sub,
          date: moment().format(),
          file
        }
      ])
    }).then(res => {
      setChat(res.chat ? JSON.parse(res.chat) : chat)
      setMessage('')
    })
  }

  const handleDownload = url => {
    window.open(url, '_blank')
  }

  const handleUpload = async event => {
    const { files } = event.target
    const fileArray = [...files]

    try {
      for (const file of fileArray) {
        const result = await postPhoto(file)

        if (result) {
          handleSend({
            fileDownloadUri: result.fileDownloadUri,
            originalFileName: result.originalFileName,
            size: result.size
          })
        }
      }
    } catch (error) {
      console.error('Error uploading files:', error)
    } finally {
      event.target.value = null
    }
  }

  return (
    <Grid
      container
      direction={'row'}
      alignItems={'center'}
      spacing={2}
      justify={'center'}
      style={{ padding: '12px 0' }}
    >
      <Grid
        container
        direction={'column'}
        style={{
          overflowY: 'auto',
          paddingBottom: 94,
          maxHeight: 500,
          flexWrap: 'nowrap'
        }}
      >
        {chat.map((item, index, array) => {
          const current = moment(item?.date).format('DD.MM.YYYY')
          const prev =
            index > 0
              ? moment(array[index - 1].date).format('DD.MM.YYYY')
              : null
          const date = prev ? (current === prev ? null : current) : current
          return (
            <>
              {date && (
                <AsterButton
                  color="default"
                  style={{
                    width: 'fit-content',
                    margin: 'auto',
                    marginBottom: 6
                  }}
                >
                  {date === moment().format('DD.MM.YYYY') ? 'Сегодня' : date}
                </AsterButton>
              )}
              <Grid
                item
                style={{
                  marginBottom: 6,
                  marginLeft: item?.author === currentUser.sub ? 'auto' : 0,
                  marginRight: item?.author !== currentUser.sub ? 'auto' : 6,
                  padding: '6px 12px',
                  width: 'fit-content',
                  maxWidth: 210,
                  borderRadius: 10,
                  color: item?.author === currentUser.sub ? '#fff' : '#000',
                  background:
                    item?.author === currentUser.sub ? primaryB : secondaryB
                }}
              >
                <span
                  style={{
                    display: 'block',
                    fontSize: 11,
                    fontWeight: '600',
                    textAlign:
                      item?.author === currentUser.sub ? 'right' : 'left'
                  }}
                >
                  {item?.fullName || 'Anonymous'}
                </span>
                <p style={{ margin: '4px 0', wordBreak: 'break-word' }}>
                  {item?.message}
                </p>
                {item?.file && (
                  <FileMessage
                    handleDownload={handleDownload}
                    url={item?.file?.fileDownloadUri}
                    size={item?.file?.size}
                    fileName={item?.file?.originalFileName}
                  />
                )}
                <span
                  style={{
                    display: 'block',
                    fontSize: 11,
                    textAlign:
                      item?.author === currentUser.sub ? 'right' : 'left'
                  }}
                >
                  {moment(item?.date).format('HH:mm')}
                </span>
              </Grid>
            </>
          )
        })}
      </Grid>
      <Grid
        item
        container
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'nowrap',
          gap: '5px',
          position: 'absolute',
          bottom: 0,
          background: '#fff'
        }}
      >
        <AsterTextField
          fullWidth
          multiline
          rows={1}
          label="Сообщение"
          name={'message'}
          value={message || ''}
          onChange={e => setMessage(e.target.value)}
        />
        <AsterButton
          component="label"
          color={'secondary'}
          style={{ height: '100%' }}
        >
          <AttachFileIcon />
          <input hidden multiple type="file" onChange={handleUpload} />
        </AsterButton>
        <AsterButton
          color={'secondary'}
          onClick={() => handleSend(false)}
          style={{ height: '100%' }}
        >
          <SendIcon />
        </AsterButton>
      </Grid>
    </Grid>
  )
}

export default ChatModal
